<!--
 * @LastEditors: 杨钊
 * @Date: 2020-04-04 13:40:53
 * @LastEditTime: 2020-04-04 22:38:30
 * @FilePath: /tiger-web/src/components/AppPreviewResource.vue
 -->
<template>
  <div class="content">
    <ul>
      <li style="white-space:nowrap;display: inline-block" v-for="(resource,index) in previewResources"
        :key="resource.rUrl">
        <el-image style="width:20em;height:20em;" class="col-sm-10" :src="resource.rUrl" lazy></el-image>
        <el-button @click="deleteResource(resource.id,index)" type="danger" icon="el-icon-delete" circle></el-button>
      </li>
    </ul>
    <br />
    <el-upload ref="upload" class="upload-demo" :http-request="fileUploadRequest"
      :action="_Global.HTTP_SERVER + '/auth/app/previewResource/add'" drag multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  mounted() {
    this.app = this.$route.params.app;
    this.getAppPreviewResource();
    this.$emit("setApp", this.app);
  },
  data() {
    return {
      previewResources: [],
      app: null
    };
  },
  methods: {
    getAppPreviewResource: function() {
      let url = this._Global.HTTP_SERVER + "/auth/app/previewResource";
      var params = {
        appId: this.app.id,
        authToken: this.getToken()
      };
      this.$http.post(url, params).then(response => {
        this.respDataHandle(response.body, data => {
          this.previewResources = data;
        });
      });
    },
    deleteResource: function(id, index) {
      let url = this._Global.HTTP_SERVER + "/auth/app/previewResource/delete";
      var params = {
        appId: this.app.id,
        authToken: this.getToken(),
        resourceId: id
      };
      this.$http.post(url, params).then(response => {
        this.respDataHandle(response.body, data => {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.previewResources.splice(index, 1);
        });
      });
    },
    fileUploadRequest(param) {
      console.log(this.app);

      let fileObj = param.file; // 相当于input里取得的files
      let fd = new FormData(); // FormData 对象
      fd.append("file", fileObj); // 文件对象
      fd.append("appId", this.app.id);
      fd.append("authToken", this.getToken());
      let url = this._Global.HTTP_SERVER + "/auth/app/previewResource/add";
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.$http.post(url, fd).then(response => {
        this.respDataHandle(response.body, data => {
          this.$message({
            message: "上传成功",
            type: "success"
          });
          this.previewResources.push(data);
        });
      });
    }
  },
  components: {}
};
</script>

<style>
img {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPreviewResource.vue